import { render, staticRenderFns } from "./KamsTable.vue?vue&type=template&id=7336a382"
import script from "./KamsTable.vue?vue&type=script&lang=js"
export * from "./KamsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports